/** Typed view of the VITE_* variables. Everything here is public. */
export const env = {
  /**
   * The API's origin in a deployed build (`VITE_API_ORIGIN`, for example
   * `https://projectxapi.simprosoftware.in`): the app calls it directly (ADR-0008). Empty in
   * development, where the Vite proxy serves `/api` on the app's own origin and
   * `VITE_API_BASE_URL` is only the proxy's target.
   */
  apiBaseUrl: (import.meta.env.VITE_API_ORIGIN ?? "").replace(/\/+$/, ""),
  /** e.g. "simpro.app": tenant slug is then read from the subdomain. */
  baseDomain: import.meta.env.VITE_BASE_DOMAIN ?? "",
  useMocks: import.meta.env.VITE_USE_MOCKS === "true",
} as const;
